import React, { useEffect, useState } from "react";
import Othertimelne from "../Timeline/others_timeline";
import AlbumsCard from "../../Gallary/Albums/AlbumsCards";
import PhotosCard from "../../Gallary/photos/Photo";
import VideosCard from "../../Gallary/Videos/video";
import ProfileBaner from "./ProflieBaner";
import LeftSidebarColunm from "./LeftSidebarColunm";
import { ProfileGet } from "../../apis/api/ProfileApi";
import { albumGet } from "../../apis/api/GalleryApis";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Lodderr from "../../components/Lodder/Lodder";

const OtherProfile = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { company_id, userId } = location.state || {};

  const [memberData, setMemberData] = useState(null);
  const [activeTab, setActiveTab] = useState("about");

  const profileData = useSelector((state) => state.ProfileSlice.profileData);
  const loading = useSelector((state) => state.ProfileSlice.loading);

  useEffect(() => {
    (async () => {
      try {
        if (userId && company_id) {
          await dispatch(ProfileGet({ userId, company_id }));
          await dispatch(albumGet({ company_id }));
        }
      } catch (error) {
        console.error("Error fetching profile or album data:", error);
      }
    })();
  }, [dispatch, userId, company_id]);

  useEffect(() => {
    if (profileData?.data) {
      setMemberData(profileData.data);
    }
  }, [profileData]);

  return (
    <>
      {loading && <Lodderr />}
      <div className="">
        {memberData ? (
          <ProfileBaner profiledata={memberData} />
        ) : (
          <p>Loading profile...</p>
        )}

        <ul className="nav nav-tabs mt-3">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "about" ? "active" : ""}`}
              onClick={() => setActiveTab("about")}
            >
              About
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "Albums" ? "active" : ""}`}
              onClick={() => setActiveTab("Albums")}
            >
              Albums
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "Photos" ? "active" : ""}`}
              onClick={() => setActiveTab("Photos")}
            >
              Photos
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "videos" ? "active" : ""}`}
              onClick={() => setActiveTab("videos")}
            >
              Videos
            </button>
          </li>
        </ul>

        <div className="mt-3">
          {activeTab === "about" && (
            <div className="row mt-4">
              <LeftSidebarColunm profileData={profileData} />
              <div className="col-md-6 fixed-column">
                <Othertimelne profileData={profileData} />
              </div>
            </div>
          )}

          {activeTab === "Albums" && (
            <div className="mt-5">
              <AlbumsCard />
            </div>
          )}

          {activeTab === "Photos" && (
            <div>
              <PhotosCard />
            </div>
          )}

          {activeTab === "videos" && (
            <div>
              <VideosCard />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default OtherProfile;
